import { Dialog } from "@headlessui/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import "./form.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faChevronDown,
  faChevronUp,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import { Mixpanel } from "../../config/Mixpanel";
import Constants, { successStories } from "../../common/constants";
import { useDispatch, useSelector } from "react-redux";
import { trackVisitor } from "../../redux/actions/userActivity";
import {
  SET_EDIT_STATUS,
  SET_LOCK_STATUS,
  SET_RESET_DATA,
  SET_USER_CV_DATA,
  SET_USER_ENGAGEMENT_DATA,
  SET_USER_FORM_DATA,
  SET_USER_LINKEDIN_URL,
  SET_USER_TYPE,
} from "../../redux/actions/types";
import {
  editUserDetails,
  getUserEngagement,
  loginWithLinkedin,
  manualLoginPhase1,
  manualLoginPhase2,
  trackUser,
} from "../../redux/actions/certificateVerification";
import TopSocialProof from "./TopSocialProof";
import CountryCode from "./CountryCode";
import { countryPhoneCodes } from "../LandingPage/countryPhoneCode";
import { PhoneNumberUtil } from "google-libphonenumber";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { motion, useAnimation } from "framer-motion";
import mixpanel from "mixpanel-browser";

const promises = [];
const role_details = [
  { role: "Recruiter / Team Leads", role_headings: "Company Name" },
  { role: "Founder / Business Owner", role_headings: "Company Name" },
  { role: "Working Professional", role_headings: "Job Role" },
  { role: "Student", role_headings: "Course" },
  { role: "Teacher", role_headings: "Name of Institute" },
  { role: "Influencers", role_headings: "Social Media Handle" },
];
const UserForm = ({ isManual , setIsManual , isModalEnabled, certificateData, openLinkedInLogin , uuid }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "",
    role_data: "",
    role_headings: "",
    phone_number: "",
  });
  const inputRef = useRef(null);
  const [isFocus, setIsFocus] = useState(false);
 
  const phoneUtil = PhoneNumberUtil.getInstance();
  const [isFocus1, setIsFocus1] = useState(false);
  const [isFocus2, setIsFocus2] = useState(false);
  const [isFocus4, setIsFocus4] = useState(false);
  const formRef = useRef(null);
  const [formHeight, setFormHeight] = useState(0);
  
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo
  );
  const nameRef = useRef(null);
  const email = useSelector((store) => store?.profileDetails?.email);
  const optRef = useRef(null);
  const editStatus = useSelector(
    (store) => store?.certificateVerification?.is_edit
  );
  const [animationComplete , setAnimationComplete] = useState(false);
  const [shakeForm, setShakeForm] = useState(false);
   const lockedState = useSelector(
      (store) => store?.certificateVerification?.is_locked
    );
   
  
  const [selectedCountry, setSelectedCountry] = useState(
    countryPhoneCodes.find((el) => el?.name === "India")
  );
  const [phoneNumber, setPhoneNumber] = useState("");
  const fourthRef = useRef(null);
  
  const dispatch = useDispatch();
  console.log(isFocus2, isFocus1, isFocus4, "text");

  console.log("monday", formData);
  function isFormActive() {
    if (
      formData?.name?.length > 0 &&
      formData?.email?.length > 0 &&
      formData?.role?.length > 0 &&
      formData?.role_data?.length > 0
    )
      return false;

    return true;
  }
  function isEditFormActive() {
    if (
      formData?.name?.length > 0 &&
      formData?.email?.length > 0 &&
      formData?.role?.length > 0 &&
      formData?.role_data?.length > 0 &&
      phoneNumber?.length > 0
    )
      return false;

    return true;
  }

  const [isFocusName, setIsFocusName] = useState(false);
  const [isFocusEmail, setIsFocusEmail] = useState(false);
  const [isFocusRoleData, setIsFocusRoleData] = useState(false);

  function submit(e) {
    e.preventDefault();


    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData?.email)){
      toast.error("Please enter a valid email address.");
    
      return;
    }
  
   
    Mixpanel.track(
      Constants.Mixpanel.CERTIFICATE_VERIFICATION_FORM_VIEW_USER_CERTIFICATE_CLICKED
    );

    
  
    dispatch(
      manualLoginPhase1(
        formData?.name,
        formData?.email,
        (successObj) => {
          dispatch(
            manualLoginPhase2(
              formData?.email,
              formData?.role,
              formData?.role_data,
              (res) => {
                dispatch({ type: SET_LOCK_STATUS, payload: false });
  
                const newFormData = {
                  name: res?.data?.name,
                  email: res?.data?.email,
                  role: res.data?.current_role,
                  role_data: res?.data?.current_role_detail,
                  role_headings: "",
                  id: res?.data?.id,
                  phone_number: res?.data?.phone_number,
                };
  
                Mixpanel.identify(formData?.email);
                Mixpanel.people.set({
                  $name: res?.data?.name,
                })

                dispatch({ type: SET_USER_FORM_DATA, payload: newFormData });
                dispatch({
                  type: SET_USER_LINKEDIN_URL,
                  payload: res?.data?.linkedin_profile_url,
                });
                dispatch({
                  type: SET_USER_CV_DATA,
                  payload: res?.data?.user_cv,
                });
  
                dispatch(
                  trackUser(
                    res?.data?.email,
                    certificateData?.unique_certificate_id,
                    certificateData?.email,
                    (successObj) => {
                   
  
                      dispatch(
                        getUserEngagement(
                          certificateData?.unique_certificate_id,
                          newFormData?.id,
                          (successObj) => {
                            const engagementData = successObj?.data;
                            const comments = engagementData?.comments || [];
  
                            const matchIndexFromEnd = [...comments]
                              .reverse()
                              .findIndex(
                                (item) =>
                                  item?.certificate_verification_users_id &&
                                  res?.data?.id &&
                                  item?.certificate_verification_users_id ===
                                    res?.data?.id
                              );
  
                            const matchIndex =
                              matchIndexFromEnd !== -1
                                ? comments.length - 1 - matchIndexFromEnd
                                : -1;
  
                            let reorderedComments = [];
  
                            if (matchIndexFromEnd !== -1) {
                              let matchedItem = comments[matchIndex];
                              matchedItem = {
                                ...matchedItem,
                                user_name: matchedItem?.user_name + " (You)",
                              };
  
                              const remaining = [
                                ...comments.slice(0, matchIndex),
                                ...comments.slice(matchIndex + 1),
                              ];
  
                              reorderedComments = [matchedItem, ...remaining];
                            } else {
                              reorderedComments = comments;
                            }
  
                            dispatch({
                              type: SET_USER_ENGAGEMENT_DATA,
                              payload: {
                                ...engagementData,
                                comments: reorderedComments,
                              },
                            });
                          },
                          (errorObj) => {}
                        )
                      );
                    },
                    (errorObj) => {}
                  )
                );
              },
              (err) => {}
            )
          );
        },
        (errorObj) => {}
      )
    );
  }
  

  function edit() {
    const regex = /^\d+$/;

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData?.email)){
      toast.error("Please enter a valid email address.");
    
      return;
    }
    if (
      (selectedCountry?.dial_code + phoneNumber)[0] === "+" &&
      regex.test((selectedCountry?.dial_code + phoneNumber).slice(1))
    ) {
      if (
        !phoneUtil.isValidNumberForRegion(
          phoneUtil.parse(phoneNumber, selectedCountry?.code),
          selectedCountry?.code
        )
      ) {
        console.log('error');
       toast.error("Enter Valid Phone Number");

 <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className="custom-toast-container"
      />
        return;
      }
    }
    dispatch(
      editUserDetails(
        formData?.email,
        formData?.role,
        formData?.role_data,
        selectedCountry?.dial_code + phoneNumber,
        formData?.name,
        userDetails?.id,
        (res) => {
          const newFormData = {
            name: res?.data?.name,
            email: res?.data?.email,
            role: res.data?.current_role,
            role_data: res?.data?.current_role_detail,
            role_headings: "",
            phone_number: res?.data?.phone_number,
            id: res?.data?.id,
          };
            toast.success("Details updated successfully.");
          dispatch({ type: SET_USER_FORM_DATA, payload: newFormData });
          dispatch({type: SET_USER_LINKEDIN_URL,payload: res?.data?.linkedin_profile_url});
          dispatch({type : SET_EDIT_STATUS , payload : false})
          dispatch({type : SET_USER_CV_DATA , payload : res?.data?.user_cv})
          dispatch(
            getUserEngagement(
              certificateData?.unique_certificate_id,
              newFormData?.id,
              (successObj) => {
                                   const engagementData = successObj?.data;

const comments = engagementData?.comments || [];

// Find last occurrence from original array
const matchIndexFromEnd = [...comments].reverse().findIndex(
  item => item?.certificate_verification_users_id && res?.data?.id && item?.certificate_verification_users_id === res?.data?.id
);

// Convert reversed index to original index
const matchIndex =
  matchIndexFromEnd !== -1 ? comments.length - 1 - matchIndexFromEnd : -1;

let reorderedComments = [];
console.log('log2' , matchIndexFromEnd , matchIndex)
if (matchIndexFromEnd !== -1) {
  let matchedItem = comments[matchIndex];
  matchedItem = {
    ...matchedItem,
    user_name: matchedItem?.['user_name'] + ' (You)'
  };

  const remaining = [
    ...comments.slice(0, matchIndex),
    ...comments.slice(matchIndex + 1)
  ];

  reorderedComments = [matchedItem, ...remaining];
} else {
  reorderedComments = comments;
}

dispatch({
  type: SET_USER_ENGAGEMENT_DATA,
  payload: { ...engagementData, comments: reorderedComments }
});

              },
              (errorObj) => {}
            )
          );
        },
        (errorObj) => {
          toast.error("Couldn’t save your changes. Please try again.");
        }
      )
    );
  }

  useEffect(() => {
    if (editStatus) {
      setIsManual(true);
    } else if (!isManual && formData?.name?.length > 0) {
      setIsManual(true);
      if(nameRef.current)
      nameRef.current.focus();
      console.log('logg2' , isManual, formData)
    }
   
  }, [editStatus, formData?.name?.length, isManual]);



  useEffect(() => {
    setFormData({
      name: userDetails?.name,
      email: userDetails?.email,
      role: userDetails?.role,
      role_data: userDetails?.role_data,
      role_headings: role_details?.find(
        (item) => item?.role === userDetails?.role
      )?.role_headings,
    });
  }, [userDetails]);

  useEffect(()=>{

  
    if(lockedState){
      mixpanel.reset();
      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_FORM_LOADED)
    }
   

    
    
  },[lockedState]);


  useEffect(()=>{
    if(editStatus){
      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_PAGE_EDIT_FORM_LOADED)
    }
  },[editStatus])


  console.log('check-print1' , userDetails?.email);

  useEffect(()=>{
if(userDetails?.phone_number){
const number = userDetails?.phone_number;

// Parse the number
const parsedNumber = phoneUtil.parseAndKeepRawInput(number);

// Get the country code (dial code)
const dialCode = `+${parsedNumber.getCountryCode()}`;

// Get the national number (without country code)
const nationalNumber = parsedNumber.getNationalNumber().toString();

setPhoneNumber(nationalNumber);
setSelectedCountry(countryPhoneCodes.find((el) => el?.dial_code === dialCode));
}


  },[phoneUtil, userDetails])


useEffect(() => {
  const handleClickOutside = (event) => {
    if (optRef.current && !optRef.current.contains(event.target)) {
      setIsFocus(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside); // desktop
  document.addEventListener('touchstart', handleClickOutside); // mobile

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
    document.removeEventListener('touchstart', handleClickOutside);
  };
}, []);

const triggerShake = () => {
  setShakeForm(true);
  setTimeout(() => setShakeForm(false), 600); // Reset after animation completes
  
  // Add phone vibration
  if ('vibrate' in navigator) {
    // Vibration pattern: [100ms vibrate, 50ms pause, 100ms vibrate, 50ms pause, 100ms vibrate]
    navigator.vibrate([100, 50, 100, 50, 100]);
  }
};


useEffect(() => {
  if (formRef.current) {
    const height = formRef.current.offsetHeight;
    setFormHeight(height);
    console.log("Form div height:", height);
    // Use the height as needed
  }
}, [formRef, animationComplete]);


useEffect(()=>{
  if(formData?.role?.length > 0){
    fourthRef?.current?.focus();
  }
},[formData?.role])

  if (editStatus) {
    return (
      <div className="w-full">
        <Dialog
          open={isModalEnabled}
          onClose={() => null}
          as="div"
          style={{ zIndex: "999999" }}
          className="inter fixed inset-0 z-10 my-auto mx-auto flex flex-col items-center justify-center"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 mx-auto bg-black/60 backdrop-blur-sm " />
          <Dialog.Title />
          <Dialog.Description />
          <div className="relative   z-[999999] flex  h-screen w-full flex-col items-center justify-center" >
            <div
              className="show-animation main absolute bottom-0 max-h-[95dvh] overflow-y-auto flex w-full flex-col items-center justify-start  rounded-t-3xl md:rounded-3xl border-t-[1.5px]  md:border-[1.5px]  bg-[#004688]/30 md:border-white/20 border-white pt-6  py-4 px-4 leading-none md:static md:w-[30%] md:px-5 md:pt-6 md:pb-8"
              style={{
                boxShadow: "0px -4px 20px rgba(0, 0, 0, 0.7)",
                backdropFilter: "blur(8px)",
                overflowY:  `scroll`,
                scrollbarWidth:   'none',       // Firefox
                msOverflowStyle:  'none', 
                webkitOverflowScrolling: 'touch'
              }}
            >
              <FontAwesomeIcon icon={faClose} className="absolute top-4 right-6 cursor-pointer text-white" onClick={() => {dispatch({type : SET_EDIT_STATUS , payload : false})}}/>
              <div className={` w-full text-left ${window.innerWidth <= 320 ? 'text-[18px]' : 'text-[20px] md:text-[22px]'}   font-semibold text-white`}>
                Want To Make Any Changes?
              </div>
              <div className="w-full text-left mt-2  text-[14px] text-white/70 text-opacity-50 md:text-[16px]">
                Edit or confirm your details to view {userDetails?.name?.split(" ")[0]}'s certificate.
              </div>
              {!isManual && (
                <>
                  <div
                    className="mt-6 w-full cursor-pointer rounded-lg bg-[#4285F4] px-6 py-3 text-center text-[18px] font-medium  leading-none text-white md:text-[20px] "
                    onClick={openLinkedInLogin}
                  >
                    Continue With LinkedIn{" "}
                    <img
                      src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/fa6-brands_linkedin.png?updatedAt=1750323926510"
                      width={18}
                      heigth={20}
                      alt=""
                      className="ml-1 -mt-1 inline-block"
                    ></img>
                  </div>

                  <div className="mt-3 flex  w-full items-center justify-center">
                    <div className="flex-1 border-[1px] border-[#FFFFFF]/20" />
                    <div className="mx-2 text-[14px] text-[#FFFFFF]/50 md:text-[16px]">
                      Or enter details manually
                    </div>
                    <div className="flex-1 border-[1px] border-[#FFFFFF]/20" />
                  </div>
                </>
              )}
              <div className="mt-6 mb-4 flex w-full flex-col items-center justify-center gap-4">
                <div className="w-full">
                  <label className="text-[14px] font-semibold text-white md:text-[16px]">
                    Your Name*
                  </label>
                  <input
                    placeholder="Full Name"
                    autoComplete="name"
                    value={formData?.name}
                    className={`input1 text-start mt-3 w-full rounded-lg border-[0.5px] border-transparent bg-[#15395E] px-4 py-3 text-sm text-white focus:border-[#7FC241] focus:outline-none md:text-[16px]`}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        name: e?.target?.value,
                      }))
                    }
                    ref={nameRef}
                    onFocus={(e) => {
                      setIsFocus1(true);
                    }}
                    onBlur={(e) => {
                      setIsFocus1(false);
                    }}
                  />
                </div>
                {isManual && (
                  <div className="flex w-full flex-col items-center justify-center gap-4">
                    <div className="w-full">
                      <label className="text-[14px] font-semibold text-white md:text-[16px]">
                        Email Address*
                      </label>
                      <input
                        placeholder="Work Email if Employed"
                        autoComplete="email"
                        value={formData?.email}
                        className={`input2 text-start mt-2 w-full rounded-lg border-[0.5px] border-transparent bg-[#15395E] px-4 py-3 text-sm text-white focus:border-[#7FC241] focus:outline-none md:text-[16px]`}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            email: e?.target?.value,
                          }))
                        }
                        onFocus={(e) => {
                          setIsFocus2(true);
                        }}
                        onBlur={(e) => {
                          setIsFocus2(false);
                        }}
                      ></input>
                    </div>
                    <div className="w-full">
                      <label className="text-[14px] font-semibold text-white md:text-[16px]">
                        Mobile Number*
                      </label>
                      <div className="flex gap-2 mt-2">
                        <div>
                          <CountryCode
                            selected={selectedCountry}
                            setSelected={setSelectedCountry}
                          />
                        </div>
                        <input
                          placeholder="Phone Number"
                          autoComplete="number"
                          value={phoneNumber}
                          className={`input2 text-start  w-full rounded-lg border-[0.5px] border-transparent bg-[#15395E] px-4 py-3 text-sm text-white focus:border-[#7FC241] focus:outline-none md:text-[16px]`}
                          onChange={(e) =>
                           setPhoneNumber(e?.target?.value)
                          }
                          onFocus={(e) => {
                            setIsFocus2(true);
                          }}
                          onBlur={(e) => {
                            setIsFocus2(false);
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="w-full">
                      <label className="text-[14px] font-semibold text-white md:text-[16px]">
                        Current Role*
                      </label>
                      <div
                        className={`relative mt-2 flex w-full cursor-pointer items-center justify-center rounded-lg bg-[#15395E] ${
                          isFocus && "border-[1px] border-[#7FC241]"
                        }`}
                      >
                        <input
                          placeholder="Select A Role"
                          className={`input3 flex w-[80%] cursor-pointer flex-col items-start justify-center rounded-l-lg border-none bg-transparent px-4 py-3 text-[14px] font-normal text-white focus:border-[#7FC241] focus:outline-none md:text-[16px]`}
                          onChange={null}
                          value={formData?.role}
                          onFocus={(e) => {
                            setIsFocus(true);
                          }}
                          readOnly
                          ref={inputRef}
                        ></input>
                        <div
                          className="flex w-[20%] cursor-pointer flex-col items-center justify-center gap-0 text-white"
                          onClick={(e) => inputRef.current.focus()}
                        >
                          <FontAwesomeIcon icon={faChevronUp} size="xs" />
                          <FontAwesomeIcon icon={faChevronDown} size="xs" />
                        </div>
                        {isFocus && (
                          <div
                            className="absolute bottom-12 z-[99999999] h-[180px] w-full overflow-scroll rounded-lg border-2 border-[#7FC241]  bg-[#15395E] p-2 text-white scrollbar-hide"
                            style={{
                              boxShadow: "0 0 12px 0 rgba(255, 255, 255, 0.2)",
                            }}
                            ref={optRef}
                          >
                            {role_details?.map((item, index) => (
                              <div
                                className={`cursor-pointer p-2 ${
                                  index != role_details?.length - 1 &&
                                  "border-b-2 border-[#19538F]"
                                } text-[14px] font-normal md:text-[16px]`}
                                onClick={(e) => {
                                  console.log("select");

                                  setFormData((prev) => ({
                                    ...prev,
                                    role: item?.role,
                                    role_headings: item?.role_headings,
                                  }));
                                  setIsFocus(false);
                                  setIsFocusRoleData(true);
                                }}
                              >
                                {item?.role}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    {formData?.role?.length > 0 && (
                      <div className="w-full">
                        <label className="text-[14px] font-semibold text-white md:text-[16px]">
                          {formData?.role_headings}*
                        </label>
                        <input
                          placeholder={`Your ${formData?.role_headings}`}
                          value={formData?.role_data}
                          className={`input4 mt-2 w-full self-start rounded-lg border-[0.5px] border-[#FFFFFF] border-opacity-[0%] bg-[#15395E] px-4 py-3 text-sm font-normal text-white focus:border-[#7FC241] focus:border-opacity-[100%] focus:outline-none md:text-[16px]`}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              role_data: e?.target?.value,
                            }));
                          }}
                        ></input>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="mt-2 flex w-full flex-col items-center justify-center">
                <button
                  disabled={isEditFormActive()}
                  className="w-full rounded-lg bg-[#7FC241] py-3 text-center text-[16px] font-semibold disabled:opacity-50 md:text-[18px]"
                  onClick={(e) => {
                    
                    Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_PAGE_EDIT_FORM_UPDATE_DETAILS_CLICKED);  edit()}}
                >
                  Update Details
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    size="lg"
                    className="ml-2"
                  />
                </button>
              </div>
              {isManual && (
                <div className="mt-3 flex flex-col items-center justify-center gap-4 text-center">
                  <div className="flex items-center  justify-start text-left text-[12px] font-normal italic text-[white]/70 md:text-[14px]">
                    <img
                      alt=""
                      width={20}
                      height={20}
                      src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/mingcute_safety-certificate-fill.png?updatedAt=1750328912828"
                      className="mr-1 inline-block"
                    />
                    Your information is 100% secure and will not be shared.
                  </div>
                </div>
              )}
            </div>
          </div>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div className="w-full">
        <Dialog
          open={isModalEnabled}
          onClose={() => null}
          as="div"
          style={{ zIndex: "999999" }}
          className="inter fixed inset-0 z-10 my-auto mx-auto flex flex-col items-center justify-center"
        >
          <Dialog.Overlay
            className="fixed inset-0 z-10 mx-auto bg-black/60 backdrop-blur-sm"
          
          />
          <Dialog.Title />
          <Dialog.Description />
          {(window.innerWidth > 758 ? (!isManual && (
  <motion.div
    initial={{ y: -100, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ type: "spring", stiffness: 400, damping: 30 , delay: 0.3}}
    className="absolute top-4 z-[10] px-2"
    onAnimationComplete={() => setAnimationComplete(true)}
  >
    <TopSocialProof certificateData={certificateData} />
  </motion.div>
)) : (!isManual && (
  <motion.div
    initial={{ y: -100, opacity: 0 }}
    animate={{ y: 0, opacity: 1  }}
    transition={{ type: "spring", stiffness: 400, damping: 30 ,delay : 0.3 }}
    className="absolute top-4 z-[10] px-2"
    onAnimationComplete={() => setAnimationComplete(true)}
  >
    <TopSocialProof certificateData={certificateData} />
  </motion.div>
)))}
           <div className="relative z-[11] flex h-screen w-full flex-col items-center justify-center"  >
            {window.innerWidth < 768 && <div className="absolute inset-0 z-[11]" 
     style={{height: `${window.innerHeight- formHeight}px`}}   
     onClick={(e)=> {
       toast.warn(`You need to fill this form to view ${certificateData?.name?.split(' ')[0]}'s certificate details`);
       triggerShake();
     }}
></div>}

            {animationComplete && <motion.div
  className="show-animation main absolute bottom-0 max-h-[95dvh] overflow-y-auto flex w-full flex-col items-center justify-start pt-[1.5px] md:p-[1.5px] rounded-t-3xl md:rounded-3xl leading-none md:static md:w-[30%]"
  style={{
    backgroundImage: 'linear-gradient(to right, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0.3) 100%)',
  }}
  initial={{ y: 100, opacity: 0 }}
  animate={{ 
    y: 0, 
    opacity: 1,
    x: shakeForm ? [-10, 10, -10, 10, -5, 5, -2, 2, 0] : 0
  }}
  transition={{
    type: "spring",
    stiffness: 400,
    damping: 30,
    delay: 0.3,
    x: shakeForm ? {
      duration: 0.6,
      ease: "easeInOut"
    } : {}
  }}
>
            <div
              className={` p-4 pt-6 md:px-5 md:pt-6 md:pb-8 rounded-t-3xl md:rounded-3xl  flex w-full flex-col items-center justify-start md:rounded-3xl leading-none`}
              style={{
                backgroundImage : 'linear-gradient(to bottom, #0E152B 0%, #121212 100%)',
                boxShadow: "0px -4px 20px rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(8px)",
                overflowY:  `scroll`,
                scrollbarWidth:   'none',       // Firefox
                msOverflowStyle:  'none', 
                webkitOverflowScrolling: 'touch'     // Internet Explorer 10+
               
              }}
              ref={formRef}
            >
              <div className={`${window.innerWidth <= 320 ? 'text-[18px]' : 'text-[20px] md:text-[22px]'}  font-semibold text-white text-center leading-[130%]`}>
              Want To Get Certified Like {certificateData?.name?.split(" ")[0]}?
              </div>
              <div className="mt-2 text-center text-[14px] text-white/50 text-opacity-50 md:text-[16px] leading-[140%]">
              You can get yours in under 10 minutes!
              </div>
              <div
                    className="mt-5 w-full border border-[#7FC241] text-[18px]  md:text-[20px] font-semibold leading-[140%] text-[#7FC241]   cursor-pointer text-center rounded-lg p-3 text-center"
                   
                    onClick={(e) =>
                      {Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_FORM_GET_CERTIFIED_CLICKED, { distinct_id: userDetails?.email, insertid: uuidv4() });

                      if(certificateData?.certificate_name){
                      window.open(
                        `https://certified.learntube.ai/skill_name=${certificateData?.certificate_name}?utm_source=certificate-verification-form&utm_medium=get-certified&unique_certificate_id=${certificateData?.unique_certificate_id}`,
                        "_blank"
                      )
                    }else{
                      window.open(
                        `https://certified.learntube.ai/?utm_source=certificate-verification-form&utm_medium=get-certified`,
                        "_blank"
                      )
                    }
                    }
                  }
                  >
                   
                      Get Your Own Certificate <FontAwesomeIcon icon={faArrowRight} size="lg" className="ml-1" />
                    

                  </div>
              {!isManual && (
                <>
                  {/* <div
                    className="mt-6 w-full cursor-pointer rounded-lg bg-[#4285F4] px-6 py-3 text-center text-[18px] font-medium  leading-none text-white md:text-[20px] "
                    onClick={(e)=> {
                      
                      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_FORM_CONTINUE_WITH_LINKEDIN_CLICKED); openLinkedInLogin()}}
                  >
                    Continue With LinkedIn{" "}
                    <img
                      src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/fa6-brands_linkedin.png?updatedAt=1750323926510"
                      width={18}
                      heigth={20}
                      alt=""
                      className="ml-1 -mt-1.5 inline-block"
                    ></img>
                  </div> */}

                  <div className="mt-8 flex  w-full items-center justify-center">
                    <div className="flex-1 border-[1px] border-[#FFFFFF]/20" />
                    <div className="mx-2 text-[14px] text-[#FFFFFF]/50 md:text-[16px]">
                      Or
                    </div>
                    <div className="flex-1 border-[1px] border-[#FFFFFF]/20" />
                  </div>
                </>
              )}
              <form onSubmit={submit} className="w-full">
              <div className="mt-8 mb-4 flex w-full flex-col items-center justify-center gap-4">
                <div className={`${window.innerWidth <=320 ? 'text-[14px]' : 'text-[16px] md:text-[18px]'}  font-medium text-white `}>Verify Identity To View {certificateData?.name?.split(" ")[0]}’s Certificate</div>
                <div className={`w-full bg-[#406AFF26] rounded-lg px-4 py-3 ${isFocusName ? "border border-[#7FC241]" : ""}`}>
                  <div className="text-[12px] font-medium text-[#70AEFF] md:text-[14px]">
                    Full Name*
                  </div>
                  <input
                    placeholder="For e.g., Suraj Sharma"
                    autoComplete="name"
                    className={`input1 text-start mt-2 w-full border-none bg-transparent text-sm text-white outline-none text-[16px] placeholder-white30`}
                    onFocus={() => setIsFocusName(true)}
                    onBlur={() => setIsFocusName(false)}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        name: e?.target?.value,
                      }))
                    }
                    tabIndex={-1}
                    ref={nameRef}
                  />
                </div>
                {isManual && (
                  <div className="flex w-full flex-col items-center justify-center gap-4">
                    <div className={`w-full bg-[#406AFF26] rounded-lg px-4 py-3 ${isFocusEmail ? "border border-[#7FC241]" : ""}`}>
                    <div className="text-[12px] font-medium text-[#70AEFF] md:text-[14px] flex items-end gap-1">
                        Email* <div className="italic text-[10px] md:text-[12px] text-white/70 font-normal">(work email if already employed)</div>
                      </div>
                      <input
                        placeholder="For e.g., surajsharma19@gmail.com"
                        autoComplete="email"
                        tabIndex={-1}
                        className={`input2 text-[14px] text-start mt-2 w-full rounded-lg border-none bg-transparent px-0 py-0 text-sm text-white outline-none md:text-[16px] placeholder-white30`}
                        onFocus={() => setIsFocusEmail(true)}
                        onBlur={() => setIsFocusEmail(false)}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            email: e?.target?.value,
                          }))
                        }
                      />
                    </div>
                    <div className={`w-full bg-[#406AFF26] rounded-lg py-3 ${isFocus && "border-[1px] border-[#7FC241]"}`}>
                      {/* <label className="text-[14px] font-semibold text-white md:text-[16px]">
                        Current Role*
                      </label> */}
                      <div
                        className={`relative flex w-full px-4 cursor-pointer items-center justify-center rounded-lg `}
                      >
                        <input
                          placeholder="Select A Role"
                          className={`text-start w-full border-none bg-transparent text-sm text-white outline-none text-[16px] placeholder-blue-70aef`}
                          onChange={null}
                          tabIndex={-1}
                          value={formData?.role}
                          onFocus={(e) => {
                            setIsFocus(true);
                          }}
                          readOnly
                          ref={inputRef}
                        ></input>
                        <div
                          className="flex w-[10%] cursor-pointer flex-col items-center justify-center gap-0 text-white"
                          onClick={(e) => inputRef.current.focus()}
                        >
                          <FontAwesomeIcon icon={faChevronUp} size="xs" />
                          <FontAwesomeIcon icon={faChevronDown} size="xs" />
                        </div>
                        {isFocus && (
                          <div
                            className="absolute bottom-12 w-full overflow-scroll rounded-lg border-2 border-[#7FC241]  bg-[#18203A] p-2 text-white scrollbar-hide"
                            style={{
                              boxShadow: "0 0 12px 0 rgba(255, 255, 255, 0.2)",
                            }}
                            ref={optRef}
                          >
                            {role_details?.map((item, index) => (
                              <div
                                className={`cursor-pointer p-2 ${
                                  index != role_details?.length - 1 &&
                                  "border-b-2 border-[#70AEFF]/20"
                                } text-[14px] font-normal md:text-[16px]`}
                                onClick={(e) => {
                                  console.log("select");

                                  setFormData((prev) => ({
                                    ...prev,
                                    role: item?.role,
                                    role_headings: item?.role_headings,
                                    role_data : "",
                                  }));
                                  setIsFocus(false);
                                 
                                }}
                              >
                                {item?.role}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    {formData?.role?.length > 0 && (
                      <div className={`w-full bg-[#406AFF26] rounded-lg px-4 py-3 ${isFocusRoleData ? "border border-[#7FC241]" : ""}`}>
                        <div className="text-[12px] font-medium text-[#70AEFF] md:text-[14px]">
                          {formData?.role_headings}*
                        </div>
                        <input
                          placeholder={`Your ${formData?.role_headings}`}
                          autoComplete="organization"
                          className={`input4 mt-2 w-full self-start rounded-lg border-none bg-transparent px-0 py-0 text-sm font-normal text-white outline-none md:text-[16px] placeholder-white30`}
                          onFocus={() => setIsFocusRoleData(true)}
                          onBlur={() => setIsFocusRoleData(false)}
                          ref={fourthRef}
                          value={formData?.role_data}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              role_data: e?.target?.value,
                            }));
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="mt-2 flex w-full flex-col items-center justify-center">
                <button
                  disabled={isFormActive()}
                  className="w-full rounded-lg bg-[#7FC241] py-3 text-center text-[16px] md:text-[18px] font-semibold disabled:opacity-50"
                  
                >
                  View {certificateData?.name?.split(" ")[0]}'s certificate
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    size="lg"
                    className="ml-2"
                  />
                </button>
              </div>
                </form>
              {/* {isManual && (
                <div className="mt-3 flex flex-col items-center justify-center gap-4 text-center">
                  <div className="text-[14px] md:text-[16px] font-medium text-[#7FC241] underline underline-offset-2 cursor-pointer"  onClick={(e)=>{Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_FORM_CONTINUE_WITH_LINKEDIN_CLICKED);openLinkedInLogin()}}>
                    Or Continue With LinkedIn
                  </div>
                 
                </div>
              )} */}
               <div className="mt-4 flex items-center  justify-start text-left text-[12px] font-normal italic text-[white]/70 md:text-[14px]">
                    <img
                      alt=""
                      width={20}
                      height={20}
                      src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/mingcute_safety-certificate-fill.png?updatedAt=1750328912828"
                      className="mr-1 inline-block"
                    />
                    Your information is 100% secure and will not be shared.
                  </div>
              {/* <div className="mt-4 flex w-full items-center justify-center gap-3 border-t-[1px] border-t-[#FFFFFF]/20 pt-4 ">
              
                  <div
                    className="border border-[#7FC241] flex cursor-pointer flex-col items-center justify-center rounded-lg p-3 text-center"
                   
                    onClick={(e) =>
                      {Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_FORM_GET_CERTIFIED_CLICKED);
                      window.open(
                        `https://certified.learntube.ai/skill_name=${certificateData?.certificate_name}?utm_source=certificate-verification-form&utm_medium=get-certified&unique_certificate_id=${certificateData?.unique_certificate_id}`,
                        "_blank"
                      )
                    }
                    }
                  >
                    <span className="text-[16px] font-semibold leading-[140%] text-[#7FC241] md:text-[18px]">
                      Get Your Own Certificate
                    </span>
                    <span className="mt-2 text-[14px] text-white/70 md:text-[16px] line-clamp-1">
                      In Under 10 Mins!
                    </span>
                  </div>
              
          
                  <div
                    className="border border-[#7FC241]  flex cursor-pointer flex-col items-center justify-center rounded-lg p-3 text-center"
                    onClick={(e) =>{
                      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_FORM_BUILD_PERSONALIZED_COURSE_CLICKED);
                      window.open(
                        "https://personalise.learntube.ai?utm_source=certificate-verification-form&utm_medium=build-course",
                        "_blank"
                      )
                    }
                    }
                    
                  >
                    <span className="text-[16px] font-semibold leading-[140%] text-[#7FC241] md:text-[18px]">
                      Build Yourself A Course
                    </span>
                    <span className="mt-2 text-[14px] text-white/70 md:text-[16px] line-clamp-1">
                      100% Personalised!
                    </span>
                  </div>
               
              </div> */}
            </div>
            </motion.div>}
          </div>
        </Dialog>
      </div>
    );
  }
};

export default UserForm;
